import * as React from 'react';
export default function Engine({...rest}) {
  return (
    <svg
      {...rest}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.59 11.1492V8.14922H23V19.1492H21.61V16.0492H20.31C19.9234 16.0492 19.61 16.3626 19.61 16.7492V19.2992C19.6107 19.8326 19.1927 20.2726 18.66 20.2992H9.78C9.41227 20.3044 9.05579 20.1725 8.78 19.9292L4.85 16.5092C4.52021 16.2264 4.3303 15.8137 4.33 15.3792V12.7292H2.33V15.7292H1V12.7292V11.3992V8.39922H2.28V11.3992H4.28V8.02922C4.28 7.47693 4.72772 7.02922 5.28 7.02922H11.42V5.02922H8.36V3.69922H15.69V4.97922H12.75V6.97922H18.64C19.1727 7.00588 19.5907 7.44589 19.59 7.97922V10.4492C19.59 10.8358 19.9034 11.1492 20.29 11.1492H21.59ZM18.29 16.7192C18.29 15.6146 19.1854 14.7192 20.29 14.7192L21.56 14.6892V12.4792H20.26C19.1554 12.4792 18.26 11.5838 18.26 10.4792V8.33922H5.66V15.3392C5.65841 15.3896 5.68065 15.4378 5.72 15.4692L9.65 18.9792C9.68602 18.989 9.72398 18.989 9.76 18.9792H18.29V16.7192Z"
        fill="white"
      />
    </svg>
  );
}
